module.exports = __webpack_public_path__ + "static/img/17-3.08be930.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/17-3.jpg
// module id = bS30
// module chunks = 0